import Table, { Column } from "@/components/Table/Table";
import ElectricityIcon from "@/components/icons/ElectricityIcon";
import EnvironmentalFootprintIcon from "@/components/icons/EnvironmentalFootprintIcon";
import HeatIcon from "@/components/icons/HeatIcon";
import WaterIcon from "@/components/icons/WaterIcon";
import DonutChart from "@/components/visualizations/DonutChart/DonutChart";
import LineChart from "@/components/visualizations/LineChart/LineChart";
import List, { ListData } from "@/components/visualizations/List/List";
import SingleBarChart from "@/components/visualizations/SingleBarChart.tsx/SingleBarChart";
import styles from "@/pages/dashboard/Dashboard.module.scss";
import { Segmented, Tabs } from "antd";
import { useEffect, useState } from "react";
import MetricWidget from "../components/MetricWidget/MetricWidget";
import Widget from "../components/Widget/Widget";
import YearPicker from "../components/YearPicker/YearPicker";

export const data = [
  {
    label: "Climate change",
    value: 6013.07,
  },
  {
    label: "Water use",
    value: 6094.14,
  },
  {
    label: "Ecosystem quality",
    value: 3456.02,
  },
  {
    label: "Toxicity",
    value: 3456.02,
  },
  {
    label: "Pollution",
    value: 1298.51,
  },
  {
    label: "Material resources",
    value: 12313.12,
  },
];

export const singleBarData = [
  {
    label: "Climate change",
    value: 6013.07,
  },
  {
    label: "Water use",
    value: 6094.14,
  },
  {
    label: "Ecosystem quality",
    value: 3456.02,
  },
];

export const lineData = [
  {
    label: "Water use",
    data: [
      {
        label: "Oct 2022",
        value: 6013.07,
      },
      {
        label: "Nov 2022",
        value: 6094.14,
      },
      {
        label: "Dec 2022",
        value: 3456.02,
      },
      {
        label: "Jan 2023",
        value: 3456.02,
      },
      {
        label: "Feb 2024",
        value: 1298.51,
      },
      {
        label: "Mar 2024",
        value: 12313.12,
      },
      {
        label: "Apr 2023",
        value: 3456.02,
      },
      {
        label: "May 2024",
        value: 1298.51,
      },
      {
        label: "Jun 2024",
        value: 12313.12,
      },
    ],
  },
  {
    label: "Electricity",
    data: [
      {
        label: "Oct 2022",
        value: 3456.02,
      },
      {
        label: "Nov 2022",
        value: 6094.14,
      },
      {
        label: "Dec 2022",
        value: 3456.02,
      },
      {
        label: "Jan 2023",
        value: 3456.02,
      },
      {
        label: "Feb 2024",
        value: 1298.51,
      },
      {
        label: "Mar 2024",
        value: 6094.14,
      },
      {
        label: "Apr 2023",
        value: 3456.02,
      },
      {
        label: "May 2024",
        value: 1298.51,
      },
      {
        label: "Jun 2024",
        value: 6094.14,
      },
    ],
  },
];

const listData: ListData = {
  list: [
    {
      label: "Water use",
      value: 20,
      extraProp: {
        label: "Weight",
        value: "10 kg",
      },
    },
    {
      label: "Water use",
      value: 40,
      extraProp: {
        label: "Weight",
        value: "10 kg",
      },
    },
    {
      label: "Water use",
      value: 90,
      extraProp: {
        label: "Weight",
        value: "10 kg",
      },
    },
    {
      label: "Water use",
      value: 46,
      extraProp: {
        label: "Weight",
        value: "10 kg",
      },
    },
    {
      label: "Water use",
      value: 46,
      extraProp: {
        label: "Weight",
        value: "10 kg",
      },
    },
  ],
  total: 2000,
};

const listDataWithIcons: ListData = {
  list: [
    {
      label: "Water use",
      value: 20,
      icon: <ElectricityIcon />,
      extraProp: {
        label: "Weight",
        value: "10 kg",
      },
    },
    {
      label: "Water use",
      value: 40,
      icon: <WaterIcon />,
      extraProp: {
        label: "Weight",
        value: "10 kg",
      },
    },
    {
      label: "Water use",
      value: 90,
      icon: <HeatIcon />,
      extraProp: {
        label: "Weight",
        value: "10 kg",
      },
    },
    {
      label: "Water use",
      value: 46,
      icon: <ElectricityIcon />,
      extraProp: { label: "Weight", value: "10 kg" },
    },
    {
      label: "Water use",
      value: 46,
      icon: <ElectricityIcon />,
      extraProp: { label: "Weight", value: "10 kg" },
    },
    {
      label: "Water use",
      value: 46,
      icon: <ElectricityIcon />,
      extraProp: { label: "Weight", value: "10 kg" },
    },
    {
      label: "Water use",
      value: 46,
      icon: <ElectricityIcon />,
      extraProp: { label: "Weight", value: "10 kg" },
    },
  ],
  total: 2000,
};

const columns: Column[] = [{ label: "Product", key: "product" }];
const tableData: Record<string, any> = {
  data1: [{ key: 0, product: "Sjoerd" }],
  data2: [{ key: 0, product: "Lotte" }],
};

export default function DemoDashboard() {
  const [loading, setLoading] = useState(true);
  const [more, setMore] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.title}>
          <h1>Transport Dashboard</h1>
          <p>
            Your product impact is your company impact minus the employee impact. Push this again.
          </p>
        </div>
        <div className={styles["date-range"]}>
          <YearPicker />
        </div>
      </div>
      <div className={styles.grid}>
        <h2>Metric widget</h2>
        <div className={styles["one-column"]}>
          <MetricWidget
            icon={<EnvironmentalFootprintIcon />}
            title={"Doughnut categorical colors"}
            tooltip={"Ja tekst hier dus"}
            format={(number) =>
              `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
            }
            loading={loading}
            data={{
              value: 12345.32,
              comparison: { label: "Share of company total", value: 22345.32 },
            }}
          />
        </div>
        <div className={styles["two-columns"]}>
          <div>
            <MetricWidget
              icon={<EnvironmentalFootprintIcon />}
              title={"Metric"}
              tooltip={"Ja tekst hier dus"}
              loading={loading}
              data={{
                value: 12345.32,
              }}
            />
            <MetricWidget
              icon={<EnvironmentalFootprintIcon />}
              title={"Metric"}
              tooltip={"Ja tekst hier dus"}
              loading={true}
              data={{
                value: 12345.32,
              }}
            />
          </div>
          <div>
            <MetricWidget
              icon={<EnvironmentalFootprintIcon />}
              title={"Metric with formatting & comparison"}
              tooltip={"Ja tekst hier dus"}
              format={(number) =>
                `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
              }
              loading={loading}
              data={{
                value: 10000,
                comparison: { label: "Share of company total", value: 22345.32 },
              }}
            />
            <MetricWidget
              icon={<EnvironmentalFootprintIcon />}
              title={"Metric no data"}
              tooltip={"Ja tekst hier dus"}
              format={(number) =>
                `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
              }
              loading={loading}
              data={undefined}
            />
          </div>
        </div>
        <h2>Table widget</h2>
        <div className={styles["one-column"]}>
          <Widget
            title={"Table widget"}
            tooltip={"Ja tekst hier dus"}
            topRight={
              <>
                <Segmented options={["Absolute", "Relative (%)"]} />
                <Segmented options={["Single product", "Product totals"]} />
              </>
            }
          >
            <Tabs
              items={[
                {
                  key: "table1",
                  label: "Table 1",
                  children: (
                    <Table
                      columns={columns}
                      loading={loading}
                      data={tableData["data1"]}
                      rowKey={"key"}
                    />
                  ),
                },
                {
                  key: "table2",
                  label: "Table 2",
                  children: (
                    <Table
                      columns={columns}
                      loading={loading}
                      data={tableData["data2"]}
                      rowKey={"key"}
                    />
                  ),
                },
              ]}
            />
          </Widget>
          <Widget
            title={"Table widget"}
            tooltip={"Ja tekst hier dus"}
            topRight={
              <>
                <Segmented options={["Absolute", "Relative (%)"]} />
                <Segmented options={["Single product", "Product totals"]} />
              </>
            }
          >
            <Tabs
              items={[
                {
                  key: "table1",
                  label: "Table 1",
                  children: (
                    <Table
                      columns={columns}
                      loading={loading}
                      data={[]}
                      rowKey={"key"}
                    />
                  ),
                },
                {
                  key: "table2",
                  label: "Table 2",
                  children: (
                    <Table
                      columns={columns}
                      loading={loading}
                      data={[]}
                      rowKey={"key"}
                    />
                  ),
                },
              ]}
            />
          </Widget>
          <Widget
            title={"Table widget"}
            tooltip={"Ja tekst hier dus"}
            topRight={
              <>
                <Segmented options={["Absolute", "Relative (%)"]} />
                <Segmented options={["Single product", "Product totals"]} />
              </>
            }
          >
            <Tabs
              items={[
                {
                  key: "table1",
                  label: "Table 1",
                  children: (
                    <Table
                      columns={columns}
                      loading={true}
                      data={[]}
                      rowKey={"key"}
                    />
                  ),
                },
                {
                  key: "table2",
                  label: "Table 2",
                  children: (
                    <Table
                      columns={columns}
                      loading={true}
                      data={[]}
                      rowKey={"key"}
                    />
                  ),
                },
              ]}
            />
          </Widget>
        </div>
        <h2>Single bar chart widget</h2>
        <div className={styles["two-columns"]}>
          <div>
            <Widget
              title={"Single bar chart widget"}
              tooltip={"Ja tekst hier dus"}
            >
              <SingleBarChart
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={singleBarData}
              />
            </Widget>
            <Widget
              title={"Single bar chart widget (no data)"}
              tooltip={"Ja tekst hier dus"}
            >
              <SingleBarChart
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={[]}
              />
            </Widget>
          </div>
          <div>
            <Widget
              title={"Single bar chart widget (loading)"}
              tooltip={"Ja tekst hier dus"}
            >
              <SingleBarChart
                loading={true}
                data={singleBarData}
              />
            </Widget>
          </div>
        </div>
        <h2>List widget</h2>
        <div className={styles["two-columns"]}>
          <div>
            <Widget
              title={"List widget (with formatting & icons)"}
              tooltip={"Ja tekst hier dus"}
            >
              <List
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={{ ...listDataWithIcons, list: listDataWithIcons.list.slice(0, more ? 7 : 5) }}
                loadMore={{ fn: () => setMore(true), numberOfMore: 2, show: !more }}
              />
            </Widget>
            <Widget
              title={"List widget (without formatting)"}
              tooltip={"Ja tekst hier dus"}
            >
              <List
                loading={loading}
                data={listData}
              />
            </Widget>
          </div>
          <div>
            <Widget
              title={"List widget (loading)"}
              tooltip={"Ja tekst hier dus"}
            >
              <List
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={true}
                data={{ ...listDataWithIcons, list: listDataWithIcons.list.slice(0, more ? 7 : 5) }}
                loadMore={{ fn: () => setMore(true), numberOfMore: 2, show: !more }}
              />
            </Widget>
            <Widget
              title={"List widget (no data)"}
              tooltip={"Ja tekst hier dus"}
            >
              <List
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={{ list: [] }}
                loadMore={{ fn: () => setMore(true), numberOfMore: 2, show: !more }}
              />
            </Widget>
          </div>
        </div>
        <h2>Line chart widget</h2>
        <div className={styles["one-column"]}>
          <Widget
            title={"Line chart categorical colors (full width)"}
            tooltip={"Ja tekst hier dus"}
          >
            <LineChart
              format={(number) =>
                `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
              }
              data={lineData}
              loading={loading}
            />
          </Widget>
        </div>
        <div className={styles["two-columns"]}>
          <div>
            <Widget
              title={"Line chart categorical colors (with formatting)"}
              tooltip={"Ja tekst hier dus"}
            >
              <LineChart
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={lineData}
              />
            </Widget>
            <Widget
              title={"Line chart categorical colors (with formatting)"}
              tooltip={"Ja tekst hier dus"}
            >
              <LineChart
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={lineData}
                stacked={true}
              />
            </Widget>
            <Widget
              title={"Line chart categorical colors (loading)"}
              tooltip={"Ja tekst hier dus"}
            >
              <LineChart
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={true}
                data={lineData}
                stacked={true}
              />
            </Widget>
          </div>
          <div>
            <Widget
              title={"Line chart ordinal colors"}
              tooltip={"Ja tekst hier dus"}
            >
              <LineChart
                colorPalette="ordinal_green"
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={lineData}
              />
            </Widget>
            <Widget
              title={"Line chart ordinal colors"}
              tooltip={"Ja tekst hier dus"}
            >
              <LineChart
                colorPalette="ordinal_green"
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={lineData}
                stacked={true}
              />
            </Widget>
            <Widget
              title={"Line chart ordinal colors (no data)"}
              tooltip={"Ja tekst hier dus"}
            >
              <LineChart
                colorPalette="ordinal_green"
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={[]}
                stacked={true}
              />
            </Widget>
          </div>
        </div>
        <h2>Donut chart widget</h2>
        <div className={styles["two-columns"]}>
          <div>
            <Widget
              title={"Doughnut (ordinal colors)"}
              tooltip={"Ja tekst hier dus"}
            >
              <DonutChart
                colorPalette="ordinal_green"
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={data}
              />
            </Widget>
            <Widget
              title={"Doughnut (loading)"}
              tooltip={"Ja tekst hier dus"}
            >
              <DonutChart
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={true}
                data={data}
              />
            </Widget>
          </div>
          <div>
            <Widget
              title={"Doughnut (categorical colors)"}
              tooltip={"Ja tekst hier dus"}
            >
              <DonutChart
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={data}
              />
            </Widget>
            <Widget
              title={"Doughnut (no data)"}
              tooltip={"Ja tekst hier dus"}
            >
              <DonutChart
                colorPalette="ordinal_green"
                format={(number) =>
                  `€${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                }
                loading={loading}
                data={[]}
              />
            </Widget>
          </div>
        </div>
      </div>
    </>
  );
}
